import { AppstoreAddOutlined, DeleteOutlined, DownOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type CtsModuleSpecsFragment } from '../../../../api/fragments/CtsModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { useCtsModuleUpdateDrawer } from './CtsModuleUpdateDrawer';

export type CtsModuleActionsProps = {
    module: CtsModuleSpecsFragment;
    openCtsSettingDrawer: () => void;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const CtsModuleActions = ({ module, openCtsSettingDrawer, permissions }: CtsModuleActionsProps) => {
    const { t } = useTranslation(['ctsModuleDetails']);

    const deleteModule = useDeleteModule(module.id);

    const updateCtsModuleDrawer = useCtsModuleUpdateDrawer(module.id, {
        displayName: module.displayName,
    });

    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('ctsModuleDetails:mainActionButtons.updateSpecs'),
            key: 'updateSpecs',
            icon: <EditOutlined />,
            onClick: updateCtsModuleDrawer.open,
        },

        hasUpdatePermission && {
            label: t('ctsModuleDetails:mainActionButtons.addSetting'),
            key: 'addSetting',
            icon: <AppstoreAddOutlined />,
            onClick: openCtsSettingDrawer,
        },

        hasDeletePermission && {
            label: t('ctsModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('ctsModuleDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {updateCtsModuleDrawer.render()}
        </>
    );
};

export default CtsModuleActions;
